import PropTypes from "prop-types";
import classes from "./button.module.css";
import { cn } from "@/utils";

export const Button = ({
  label,
  onClick,
  leftIcon,
  rightIcon,
  className,
  variant = "primary",
  parent,
  customStyle,
  disabled,
  children,
  width,
  background,
  color,
  isHover,
  isSimpleHover,
  type = "square",
  ...props
}) => {
  return (
    <>
      <button
        className={cn(
          classes.btn,
          isHover && classes.hover,
          isSimpleHover && classes.isSimpleHover,
          className && className
        )}
        style={customStyle && customStyle}
        onClick={onClick}
        disabled={disabled ? disabled : false}
        data-variant={variant}
        data-type={type}
        {...props}
      >
        {/* {parent} */}
        {/* {props} */}
        {leftIcon && leftIcon}
        {label && label}
        {children && children}
        {rightIcon && rightIcon}
      </button>
    </>
  );
};

Button.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  customStyle: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  onClick: undefined,
  customStyle: {},
};
